import React from "react";
import "./VideoBox.css";
import VideoBoxGIF from "../../assets/VideoBoxScreenRecord.gif";

// Importing profile images
import Profile1 from "../../assets/VideoBoxProfilePhotos/Profile1.png";
import Profile2 from "../../assets/VideoBoxProfilePhotos/Profile2.png";
import Profile3 from "../../assets/VideoBoxProfilePhotos/Profile3.png";
import Profile4 from "../../assets/VideoBoxProfilePhotos/Profile4.png";
import Profile5 from "../../assets/VideoBoxProfilePhotos/Profile5.png";
import Profile6 from "../../assets/VideoBoxProfilePhotos/Profile6.png";
import Profile7 from "../../assets/VideoBoxProfilePhotos/Profile7.png";
import Profile8 from "../../assets/VideoBoxProfilePhotos/Profile8.png";
import Profile9 from "../../assets/VideoBoxProfilePhotos/Profile9.png";

const VideoBox = () => {
  return (
    <div className="video-box-outer">
      <div className="video-box-inner">
        <img src={VideoBoxGIF} alt="Demo Animation" className="video-gif" />
      </div>

      <div className="profile-crown">
        {[Profile1, Profile2, Profile3, Profile4, Profile5, Profile6, Profile7, Profile8, Profile9].map((profile, index) => (
          <img
            src={profile}
            alt={`Profile ${index + 1}`}
            className="profile-img-vb"
            key={index}
          />
        ))}
      </div>
    </div>
  );
};

export default VideoBox;